import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'base_role',

  can: {
    route() {
      return this.child && (this.isAdmin() || this.isBaseRole()) && !this.isAgentRole();
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/BaseRoleNotAgentPerimeter.js